import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui'
import { SHORTCUTS } from '@/constants/shortcuts'

const EXTRA = [
  { keys: ['Enter'], label: 'In search: add the scanned / only match' },
  { keys: ['3*code'], label: 'In search: add 3 of an item' },
  { keys: ['Esc'], label: 'Clear search / close dialog' },
  { keys: ['⌥1', '⌥2', '⌥3'], label: 'Payment: cash / card / mobile' },
  { keys: ['Enter'], label: 'Payment: complete · Receipt: next sale' },
]

export const ShortcutsDialog = ({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent size="md">
      <DialogHeader>
        <DialogTitle>Keyboard shortcuts</DialogTitle>
        <DialogDescription>A whole sale can be rung up without touching the mouse.</DialogDescription>
      </DialogHeader>
      <dl className="grid gap-x-6 gap-y-2 sm:grid-cols-2">
        {[...Object.values(SHORTCUTS), ...EXTRA].map(({ label, keys }) => (
          <div key={label} className="flex items-center justify-between gap-3 border-b border-border-subtle py-1.5">
            <dt className="text-sm text-text-2">{label}</dt>
            <dd className="flex gap-1">
              {keys.map((k) => (
                <kbd key={k} className="inline-flex h-6 min-w-6 items-center justify-center rounded-xs border border-border bg-subdued px-1.5 text-xs font-medium text-ink">
                  {k}
                </kbd>
              ))}
            </dd>
          </div>
        ))}
      </dl>
    </DialogContent>
  </Dialog>
)
